<template>
  <div class="relative w-full md:max-w-[41.5rem]">
    <label
      class="text-text-secondary"
      :class="[
        'absolute',
        'top-0',
        'left-8',
        'px-8',
        'bg-surface-primary',
        'w-fit',
        'text-14',
        'leading-22',
      ]"
      :for="id"
    >
      {{ label }}
    </label>
    <select
      :id="id"
      v-model="selected"
      :name="name"
      class="appselect"
      :class="[
        classes !== undefined ? classes : undefined,
        'peer',
        'inline-block',
        'w-full',
        'border-border-primary',
        'border-solid',
        'border-md',
        'rounded-xl',
        'h-56',
        'px-16',
        'mt-11',
        'mb-8',
        'shadow-grey-500',
        'shadow-[inset_1px_1px_0_1px]',
        'bg-surface-primary',
        'text-text-primary',
        'text-18',
        'leading-20',
        'cursor-pointer',
      ]"
    >
      <option v-for="opt in options" :key="opt.value" :value="opt.value">
        {{ opt.label }}
      </option>
    </select>
    <nuxt-icon
      class="absolute right-18 top-27 text-24 text-text-primary"
      aria-hidden="true"
      name="chevron-down"
    />
    <span
      :class="[
        ` absolute
          bg-blue-500
          h-4
          left-4
          right-2
          top-[6.1rem]
          border-solid
          border-b-12
          border-l-12
          rounded-bl-xl
          rounded-br-xl
          transition-all
          duration-300
          ease-in
          opacity-0
          peer-hover:opacity-100
          peer-hover:peer-disabled:opacity-0`,
      ]"
      aria-hidden="true"
    />
  </div>
</template>

<script lang="ts" setup>
export interface AppSelectOption {
  label: string;
  value: string;
}

interface Props {
  id: string;
  name: string;
  label: string;
  options: AppSelectOption[];
  classes?: string;
}

withDefaults(defineProps<Props>(), {
  classes: undefined,
});

const selected = defineModel<string>();
</script>

<style lang="scss" scoped>
.appselect {
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  text-indent: 1px;
  text-overflow: '';
}

.appselect::-ms-expand {
  display: none;
}
</style>
